module.exports = __webpack_public_path__ + "img/solution_building6.12735e08.png";